import { useTheme } from "../../styles/theme";
import { useApp } from "../../context/AppContext";
import { dispDate } from "../../utils/dates";
import { fmt } from "../../utils/format";
import SectionTitle from "../../components/SectionTitle";
import Field from "../../components/Field";

export default function Salaries() {
  const S = useTheme();
  const { data, form, setForm, TODAY, addSalary, del } = useApp();

  return (
    <div>
      <SectionTitle>Pay Employee Salary</SectionTitle>

      {/* Add form */}
      <div style={S.formCard}>
        <div style={S.formGrid}>
          <Field label="Employee Name">
            <input style={S.input} placeholder="e.g. Ramesh Kumar"
              value={form.employee || ""}
              onChange={e => setForm({ ...form, employee: e.target.value })} />
          </Field>
          <Field label="Amount (₹)">
            <input style={S.input} type="number" placeholder="0"
              value={form.salAmt || ""}
              onChange={e => setForm({ ...form, salAmt: e.target.value })} />
          </Field>
          <Field label="Pay Date">
            <input style={S.input} type="date"
              value={form.salDate || TODAY}
              onChange={e => setForm({ ...form, salDate: e.target.value })} />
          </Field>
          <Field label="Note">
            <input style={S.input} placeholder="e.g. March salary"
              value={form.salNote || ""}
              onChange={e => setForm({ ...form, salNote: e.target.value })} />
          </Field>
        </div>
        <div style={{ ...S.creditNote, borderLeftColor: S.colors.indigo }}>
          👤 Paid <strong>same day</strong>
        </div>
        <button style={{ ...S.submitBtn, background: S.colors.indigo }} onClick={addSalary}>
          + Pay Salary
        </button>
      </div>

      {/* History table */}
      <SectionTitle style={{ marginTop: 24 }}>Salary History</SectionTitle>
      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              {["Employee","Amount","Date","Note","Action"].map(h => (
                <th key={h} style={S.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.salaries.length === 0 && (
              <tr><td colSpan={5} style={S.emptyCell}>No salary records yet.</td></tr>
            )}
            {data.salaries.map(s => (
              <tr key={s.id} style={S.tr}>
                <td style={S.td}>{s.employee}</td>
                <td style={{ ...S.td, fontWeight: 700, color: S.colors.indigo }}>{fmt(s.amount)}</td>
                <td style={S.td}>{dispDate(s.date)}</td>
                <td style={S.td}>{s.note || "—"}</td>
                <td style={S.td}>
                  <button style={{ ...S.smallBtn, ...S.deleteBtn }} onClick={() => del("salaries", s.id)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
